var _componentTokenfield = function() {
    if (!$().tokenfield) {
        console.warn('Warning - tokenfield.min.js is not loaded.');
        return;
    }

    $('.js-tokenfield').each(function() {
        var $me = $(this);
        var settings = {};
        
        if ($me.data('blur')) {
            settings.createTokensOnBlur = true;
        }
        
        if ($me.data('delimiter')) {
            settings.delimiter = $me.data('delimiter');
        }
        
        if ($me.data('limit')) {
            settings.limit = $me.data('limit');
        }
        
        $me.tokenfield(settings);
    });
};

function init() {
    _componentTokenfield();
}

export const TagInputs = {
    init
}